module.exports = __webpack_public_path__ + "static/media/cactus.ad8ee816.png";